/* eslint-disable react-hooks/exhaustive-deps */

import { Grid } from "@material-ui/core"
import { InputTextMaster, MasterButton, Modal } from "App/Component/ui"
import { instance2 } from "App/constants"
import fileDownload from "js-file-download"
import React from "react"
import { useEffect } from "react"
import { useState } from "react"

function ModalCetakManualSEP({ setShowModal, showModal, formData }) {
  const [formSep, setFormSep] = useState(() => {
    return {
      no_kartu: formData.insurance_no,
      nama_peserta: formData.nama_rm,
      tlp: formData.nohp,
      tlp_lain: formData.phone_number,
      poli_tujuan: "",
      diagnosa_awal: "",
      catatan: "",
    }
  })

  useEffect(() => {
    setFormSep({
      no_kartu: formData.insurance_no,
      nama_peserta: formData.nama_rm,
      tlp: formData.nohp,
      tlp_lain: formData.phone_number,
      poli_tujuan: formData.spesialis_name,
      diagnosa_awal: "",
      catatan: "",
    })
  }, [showModal])

  const handleChange = (text) => (e) => {
    setFormSep({
      ...formSep,
      [text]: e.target.value,
    })
  }

  const handleClickPdf = async () => {
    const response = await instance2.post(
      "/sep_regist/cetak-pdf-manual",
      formSep,
      {
        responseType: "blob",
      },
    )

    fileDownload(
      response.data,
      `${formData.patients_id}_${formSep.nama_peserta}.pdf`,
    )
  }

  if (showModal) {
    return (
      <Modal
        title={"CETAK MANUAL SEP"}
        show={() => setShowModal(!showModal)}
        width="60%"
      >
        <form>
          <Grid container spacing={1}>
            <Grid item sm={4}>
              <InputTextMaster
                name="no_kartu"
                label="NO KARTU"
                id="no_kartu"
                type="text"
                value={formSep.no_kartu}
                placeholder="No Kartu"
                onChange={handleChange("no_kartu")}
              />
            </Grid>
            <Grid item sm={4}>
              <InputTextMaster
                name="nama_peserta"
                label="NAMA PESERTA"
                id="nama_peserta"
                type="text"
                value={formSep.nama_peserta}
                placeholder="Nama Peserta"
                onChange={handleChange("nama_peserta")}
              />
            </Grid>
            <Grid item sm={4}>
              <InputTextMaster
                name="tlp"
                label="TLP"
                id="tlp"
                value={formSep.tlp}
                type="text"
                placeholder="Tlp"
                onChange={handleChange("tlp")}
              />
            </Grid>

            <Grid item sm={4}>
              <InputTextMaster
                name="tlp_lain"
                label="TLP LAIN"
                id="tlp_lain"
                value={formSep.tlp_lain}
                type="text"
                placeholder="Tlp Lain"
                onChange={handleChange("tlp_lain")}
              />
            </Grid>

            <Grid item sm={4}>
              <InputTextMaster
                name="poli_tujuan"
                label="POLI TUJUAN"
                id="poli_tujuan"
                type="text"
                placeholder="Poli Tujuan"
                value={formSep.poli_tujuan}
                onChange={handleChange("poli_tujuan")}
              />
            </Grid>
            <Grid item sm={4}>
              <InputTextMaster
                name="diagnosa_awal"
                label="DIAGNOSA AWAL"
                id="diagnosa_awal"
                type="text"
                value={formSep.diagnosa_awal}
                placeholder="Diagnosa Awal"
                onChange={handleChange("diagnosa_awal")}
              />
            </Grid>
            <Grid item sm={4}>
              <InputTextMaster
                name="catatan"
                label="catatan"
                id="catatan"
                type="text"
                placeholder="catatan"
                onChange={handleChange("catatan")}
              />
            </Grid>
          </Grid>

          <MasterButton
            className="mt-1"
            type={"button"}
            color="warning"
            name="PDF"
            onClick={(e) => handleClickPdf(e)}
            size="lg"
          />
        </form>
      </Modal>
    )
  } else {
    return <></>
  }
}

export const useModalCetakManualSEP = ({ formData }) => {
  const [showModalCetakManualSEP, setShowModalCetakManualSEP] = useState(false)

  const ButtonCetakManualSEP = () => {
    return (
      <MasterButton
        type="button"
        color="purple"
        name="CETAK MANUAL SEP"
        outline={true}
        size="md"
        onClick={() => setShowModalCetakManualSEP(!showModalCetakManualSEP)}
      />
    )
  }

  const ModalPrintManualSep = () => {
    return (
      <ModalCetakManualSEP
        formData={formData}
        setShowModal={setShowModalCetakManualSEP}
        showModal={showModalCetakManualSEP}
      />
    )
  }

  return {
    ButtonCetakManualSEP,
    ModalPrintManualSep,
  }
}

export default ModalCetakManualSEP
